import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { FormGroup } from '@angular/forms';
import { SharedModalInfoComponent } from '../../../../shared/modal-info/modal-info.component';
import { PixKeyType } from '../../models/key-type.enum';
import { PixPaymentFavored } from '../../models/payment-favored.model';
import { PixPaymentKeyService } from '../payment-key.service';
import { Util } from '../../../../utils/util';
import { PixPaymentFavoredView } from '../../models/payment-favored-view.model';
import { Auth } from '../../../../autentication/Auth';
import { EventTypes } from '../../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { AutenticationService } from '../../../../autentication/autentication.service';
import { PixKeysService } from '../../keys/keys.service';
import { data } from 'jquery';

@Component({
	selector: 'app-pix-payment-key-assignature',
	templateUrl: './assignature.component.html',
	styleUrls: ['./assignature.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixPaymentKeyAssignatureComponent implements OnInit {

	public submited = false;
	public form: FormGroup;
	public selectedPixPaymentFavoredView: PixPaymentFavoredView;

	constructor(
		private route: ActivatedRoute,
		private autenticationService: AutenticationService,
		private pixPaymentKeyService: PixPaymentKeyService,
		private pixKeysService: PixKeysService,
		private router: Router,
		public dialog: MatDialog
	) {}

	ngOnInit() {
		this.selectedPixPaymentFavoredView = this.pixPaymentKeyService.getSelectedPixPaymentFavoredViewToDelete();

		if (this.invalidParams()) {
			this.goBack();
		}
	}

	invalidParams(): boolean {
		return this.selectedPixPaymentFavoredView === undefined || this.selectedPixPaymentFavoredView.sequencial === undefined;
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
	}

	submit(message: boolean) {
		this.submited = message;

		if (this.submited && this.form.valid) {
			this.addAuthToken();
			this.sendAssignature();
		}
	}

	addAuthToken() {
		if (this.form.value.token) {
			Auth.passToken = this.form.value.token;
		}
	}

	addAuthSignature() {
		if (this.form.value.eletronicSignature) {
			Auth.assinaturaEletronica = this.form.value.eletronicSignature;
		}
	}

	sendAssignature() {
		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(data => {
			if (data.Sucesso) {
				this.addAuthSignature();
				this.sendRequest();
			}
		}, error => {
			this.handleError(error);
		});
	}

	sendRequest() {
		this.pixKeysService.deleteFavored(this.selectedPixPaymentFavoredView.sequencial).subscribe(result => {
			if (result.Sucesso) {
				this.openModal();
			}
		});
	}

	openModal() {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '300px',
			data: {
				title: 'Favorecido excluído com sucesso!',
				topText: this.selectedPixPaymentFavoredView.nome + ' ' + this.getTopText(this.selectedPixPaymentFavoredView),
				btnName: 'Fechar',
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.router.navigate(['pix/pagamento']);
			}
		});
	}

	getTopText(item: PixPaymentFavoredView): string {
		switch (item.tipoChave) {
			case PixKeyType.CPF:
				return '- CPF: ' + Util.formatCpfCnpj(item.codigo);
			case PixKeyType.CNPJ:
				return '- CNPJ: ' + Util.formatCpfCnpj(item.codigo);
			case PixKeyType.EMAIL:
				return '- E-mail: ' + item.codigo;
			case PixKeyType.PHONE:
				return '- Telefone celular: ' + Util.formatPhone(item.codigo);
			case PixKeyType.EVP:
				return '- Chave aleatória: ' + item.codigo;
			case PixKeyType.MANUAL:
				return '- Ag: ' + item.numeroAgencia + ' Conta: ' + item.numeroConta;
		}
	}


	goBack = () => this.router.navigate(['pix/pagamento/']);
	handleError = (error) => AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/payment-key/assignature/assignature.component.ts